import * as actionEventypes from "../constants/eventtypeConstants";

export const getEventypesReducer = (state = { types: [] }, action) => {
    switch (action.type) {
        case actionEventypes.GET_EVENTTYPES_REQUEST:
           return {
               ...state,
               types: action.payload,
           }
        case actionEventypes.SAVE_ATTR:
            return {
                ...state,
                types: action.payload,
            }
        case actionEventypes.INSERT_EVENTTYPE:
            return {
                ...state,
                types: action.payload,
            }
        case actionEventypes.DELETE_EVENTTYPE:
            return {
               ...state,
               types: action.payload,
            }
        default:
            return state;
    }
}